// Human-readable labels for the report surfaces — FE-SCRM-058.

import type { ReportPeriod } from "./types";


export const PERIOD_LABEL: Record<ReportPeriod, string> = {
  month: "Last 30 days",
  quarter: "Last 90 days",
  year: "Last 365 days",
  all: "All time",
};


export const PERIOD_OPTIONS: { value: ReportPeriod; label: string }[] = [
  { value: "month", label: "Month" },
  { value: "quarter", label: "Quarter" },
  { value: "year", label: "Year" },
  { value: "all", label: "All time" },
];


// Mirrors backend ``LostReason`` choices (BE-SCRM-004 §lost_reason).
export const LOST_REASON_LABEL: Record<string, string> = {
  incumbent_retained: "Incumbent retained",
  lost_to_named_broker: "Lost to named broker",
  price: "Price",
  no_decision: "No decision",
  account_dissolved: "Account dissolved",
  account_acquired_by_parent: "Account acquired by parent",
  service_concern: "Service concern",
  relationship_concern: "Relationship concern",
  compliance_concern: "Compliance concern",
  coverage_gap_concern: "Coverage gap concern",
  other: "Other",
};


// Mirrors backend ``ProspectSource``.
export const SOURCE_LABEL: Record<string, string> = {
  referral: "Referral",
  cold_outreach: "Cold outreach",
  inbound: "Inbound",
  carrier_referral: "Carrier referral",
  event: "Event",
  form5500_research: "Form 5500 research",
  other: "Other",
};


export const STAGE_LABEL: Record<string, string> = {
  lead: "Lead",
  meeting_set: "Meeting set",
  qualified: "Qualified",
  proposal: "Proposal",
  negotiation: "Negotiation",
  bor_signed_pending_effective_date: "BOR signed",
  closed_won: "Closed won",
  closed_lost: "Closed lost",
};


// Velocity-tile window options — spec §FE-SCRM-058 calls out
// 90 / 180 / 365 day surfaces; the BE clamps to [7, 365] and 90 is
// the default.
export const VELOCITY_WINDOWS: { value: number; label: string }[] = [
  { value: 90, label: "90 days" },
  { value: 180, label: "180 days" },
  { value: 365, label: "365 days" },
];


// Mirrors ``backend.sales.models.normalize_company_name``: lowercase
// + collapse non-alphanumerics to single spaces + trim. Used by the
// competitor side panel to match opportunities to a competitor row.
export function normalizeCompanyName(value: string | null | undefined): string {
  if (!value) return "";
  return value.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}


export function formatCents(cents: number | null | undefined): string {
  const dollars = (cents ?? 0) / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(dollars);
}


export function formatPercent(ratio: number | null | undefined): string {
  if (ratio === null || ratio === undefined || Number.isNaN(ratio)) {
    return "—";
  }
  return `${Math.round(ratio * 100)}%`;
}


export function formatDays(days: number | null | undefined): string {
  if (days === null || days === undefined || Number.isNaN(days)) {
    return "—";
  }
  const rounded = Math.round(days * 10) / 10;
  return `${rounded}d`;
}
